var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSelectedFiltersIconMultiColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#selectedFiltersIconMultiColor_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M.08 1.24A.725.725 0 0 1 .727.842h12.085c.279 0 .528.16.648.398.12.25.1.538-.07.758L8.697 8.184v4.494c0 .258-.14.498-.358.627a.728.728 0 0 1-.717.01L5.2 11.99a.734.734 0 0 1-.38-.638V8.184L.15 2.007a.715.715 0 0 1-.07-.767Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M15.611 9.913H13.69V8h-1.804v1.913H9.963v1.813h1.922v1.913h1.804v-1.913h1.922V9.913Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "selectedFiltersIconMultiColor_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .842h16v14.316H0z"
})))));
export default SvgSelectedFiltersIconMultiColor;